module.exports = __webpack_public_path__ + "441479eab7aed582920f297039a1c2fa.svg";